import { C8AttributeKey } from "csi/typings";
import CustomViewAttribute from "./CustomViewAttribute";

/** return attributes to select between two attributes */
export function getAttributesToSelect(
	attributeIds: C8AttributeKey[],
	lastSelectedItem: CustomViewAttribute,
	item: CustomViewAttribute,
): C8AttributeKey[] {
	const lastSelectedIndex = attributeIds.indexOf(lastSelectedItem.id);
	const currentIndex = attributeIds.indexOf(item.id);
	// select all the attributes in-between the last selected item and the current item
	let attributeIdsToSelect = attributeIds.slice(lastSelectedIndex + 1, currentIndex + 1);
	if (lastSelectedIndex > currentIndex) {
		attributeIdsToSelect = attributeIds.slice(currentIndex, lastSelectedIndex + 1);
	}
	return attributeIdsToSelect;
}

/** return true if two attributes are both selected */
export function twoAttributesAreSelected(a: CustomViewAttribute, b: CustomViewAttribute): boolean {
	return a.selected && b.selected;
}

/** return true if two attributes have parent groups that are selected */
export function twoAttributesHaveGroupsThatMatchSelection(a: CustomViewAttribute, b: CustomViewAttribute): boolean {
	return a.parentGroup.selected === b.parentGroup.selected;
}

/** return true if two attributes are in the same parent group */
export function twoAttributesHaveMatchingGroup(a: CustomViewAttribute, b: CustomViewAttribute): boolean {
	return a.parentGroup.id === b.parentGroup.id;
}

/** return true if two attributes are in the same container */
export function twoAttributesHaveMatchingContainer(a: CustomViewAttribute, b: CustomViewAttribute): boolean {
	return a.container.uniqueId === b.container.uniqueId;
}

/** return true if two attributes have matching parent group and container */
export function twoAttributesHaveMatchingGroupAndContainer(a: CustomViewAttribute, b: CustomViewAttribute): boolean {
	return twoAttributesHaveMatchingContainer(a, b) && twoAttributesHaveMatchingGroup(a, b);
}